import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	placeholder: {
		id: 'issue-field-issue-links.edit.search.placeholder',
		defaultMessage: 'Select Issue',
		description: 'Placeholder text for select component',
	},
	openIssues: {
		id: 'issue-field-issue-links.edit.search.open-issues',
		defaultMessage: 'Open Issues',
		description: '',
	},
	noHistoryResults: {
		id: 'issue-field-issue-links.edit.search.no-history-results',
		defaultMessage: 'Type to search for an issue summary or key',
		description:
			'Shown to a user when there are no automatically suggested issues available to display',
	},
	singleInvalidIssue: {
		id: 'issue-field-issue-links.edit.search.single-invalid-issue',
		defaultMessage: "We can't find an issue with the key",
		description: '',
	},
	multipleInvalidIssues: {
		id: 'issue-field-issue-links.edit.search.multiple-invalid-issues',
		defaultMessage: "We can't find issues with the keys",
		description: '',
	},
	createNewIssueLink: {
		id: 'issue-field-issue-links.edit.search.create-new-issue-link',
		defaultMessage: 'Exact key',
		description: '',
	},
	placeholderIssueTermRefresh: {
		id: 'issue-field-issue-links.edit.search.placeholder-issue-term-refresh',
		defaultMessage: 'Select work item',
		description: 'Placeholder text for select component',
	},
	openIssuesIssueTermRefresh: {
		id: 'issue-field-issue-links.edit.search.open-issues-issue-term-refresh',
		defaultMessage: 'Open work items',
		description: '',
	},
	noHistoryResultsIssueTermRefresh: {
		id: 'issue-field-issue-links.edit.search.no-history-results-issue-term-refresh',
		defaultMessage: 'Type to search for a work item or key',
		description:
			'Shown to a user when there are no automatically suggested issues available to display',
	},
	singleInvalidIssueIssueTermRefresh: {
		id: 'issue-field-issue-links.edit.search.single-invalid-issue-issue-term-refresh',
		defaultMessage: "We can't find a work item with the key",
		description: '',
	},
	multipleInvalidIssuesIssueTermRefresh: {
		id: 'issue-field-issue-links.edit.search.multiple-invalid-issues-issue-term-refresh',
		defaultMessage: "We can't find work items with the keys",
		description: '',
	},
	enhanceMultiSelectLinkedIssueEnableText: {
		id: 'issue-field-issue-links.edit.search.enhance-multi-select-linked-issue-enable-text',
		defaultMessage: 'Type, search or paste URL to link work items',
		description:
			'Instructional text shown when the enhanced multi-select linking feature is enabled. Guides users to type, search, or paste URLs to efficiently link multiple issues or work items in a single action.',
	},
	searchMessage: {
		id: 'issue-field-issue-links.edit.search.search-message',
		defaultMessage: 'Type, search or paste URL',
		description:
			'Placeholder text shown when the enhanced multi-select linking feature is enabled. Guides users to type, search, or paste URLs to efficiently link multiple issues or work items in a single action.',
	},
});
